// export const API_HOST = 'https://sandbox.api.markoutpro.com/v1/'
export const API_HOST = 'http://localhost:3000/v1/'

export const settings = {
    version: require('../../package.json').version + 'dev',
    emailAddress: 'info@markoutpro.com',
    accessTokenKey: 'access_token',
    refreshTokenKey: 'refresh_token',
    sessionIdKey: 'session_id'
}